import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router-dom/es/Link';
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown';
import { Box } from 'signoxe/components/layout';
import { Button, Icon } from 'signoxe/components/widgets';
import { NotificationPropType } from 'signoxe/constants/propTypes';
import './styles.scss';

const NotificationsDropdown = ({
                                 notifications,
                                 unreadNotificationCount,
                                 onMarkAllNotificationsRead,
                               }) => (
  <Dropdown>
    <DropdownTrigger className="notifications-dropdown-triggers">
      <Icon title="Notifications"
            name="envelope"
            size="1.1rem"
            margin="0.5rem"
            color="white"/>
      {unreadNotificationCount > 0 &&
      <span className="badge alert">{unreadNotificationCount}</span>}
    </DropdownTrigger>
    <DropdownContent className="notifications-dropdown card depth-1">
      {notifications && notifications.map(notification => (
        <li key={`notif-${notification.id}`}
            className={classnames({'unread': !notification.is_read})}>
          <img src={notification.icon} alt={notification.topic}/>
          <Link className="title"
                to={`/notifications/${notification.id}`}>{notification.title}</Link>
        </li>
      ))}
      <Box direction="row" justifyContent="flex-end">
        <Button onClick={onMarkAllNotificationsRead} primary className="small">
          Mark all Read <Icon name="check" size="1em" margin="0" color="white"/>
        </Button>
      </Box>
    </DropdownContent>
  </Dropdown>
);

NotificationsDropdown.propTypes = {
  notifications: PropTypes.arrayOf(NotificationPropType),
  unreadNotificationCount: PropTypes.number,
  onMarkAllNotificationsRead: PropTypes.func.isRequired,
};

export default NotificationsDropdown;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/NotificationsDropdown/index.js